import type { InterventionLite } from "@/entities/intervention";
import type { Dayjs } from "dayjs";

import { useInterventionsBatchUpdate } from "@/entities/interventions";
import { useBatchEditForm } from "@/modules/batch-edit-form";
import { isSameDayInString, parseDate, toDateString } from "@/utilities/date";

const fieldName = "scheduled_date";

export const useInterventionsBatchEditScheduledDate = (
  interventions: InterventionLite[]
) => {
  const initialValue = parseDate(interventions[0]?.[fieldName]);

  const { mutate, isPending, status, error } =
    useInterventionsBatchUpdate(interventions);

  const onMutateReady = (value: Dayjs | null) => {
    mutate({ [fieldName]: toDateString(value) });
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    isEqualFn: ({ initialValue, formValue }) =>
      isSameDayInString(initialValue, formValue),
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
